const STREAMING_SUFFIX_LENGTH = 1024;

function trimTrailingSetextTrigger(content: string): string {
    return content.replace(/(?:\r?\n)[ \t]*-[ \t]*$/, '');
}

function trimTrailingPartialLink(content: string): string {
    const lineStart = content.lastIndexOf('\n') + 1;
    const line = content.slice(lineStart);

    const partialLinkMatch = line.match(/\[[^\]\n]*\]\([^\)\n]*$/);
    if (partialLinkMatch?.index !== undefined) {
        return content.slice(0, lineStart + partialLinkMatch.index);
    }

    const partialLinkTextMatch = line.match(/\[[^\]\n]*$/);
    if (partialLinkTextMatch?.index !== undefined) {
        return content.slice(0, lineStart + partialLinkTextMatch.index);
    }

    return content;
}

export function sanitizeStreamingMarkdown(content: string): string {
    if (!content) {
        return content;
    }

    const suffixStart = Math.max(0, content.length - STREAMING_SUFFIX_LENGTH);
    const prefix = content.slice(0, suffixStart);
    let suffix = content.slice(suffixStart);

    suffix = trimTrailingSetextTrigger(suffix);
    suffix = trimTrailingPartialLink(suffix);

    return suffix.length === content.length - suffixStart ? content : prefix + suffix;
}
